import { icons, images } from "assets";
import { Header } from "Components/header/Header";
import SettingsCard from "Components/shared/cards/SettingsCard";
import Loader from "Components/shared/loaders/OverlayLoader";
import Text from "Components/shared/text";
import { Status } from "Components/shared/transactions";
import React, { startTransition, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  fetchUserProfile,
  getUsersProfile,
  useGetUsersBank,
  useGetUsersProfile,
} from "services/accountsService";
import { USERPROFILE } from "services/localStorageaKey";
import { Storage } from "utils/clientStorage";
import styles from "./account.module.css";

const Account = () => {
  const navigate = useNavigate();
  const [profile, setUserProfile] = useState(null);

  useEffect(() => {
    const profile = Storage.getItem(USERPROFILE);
    if (!profile) {
      getData();
    } else {
      setUserProfile(profile);
    }
  }, []);

  const getData = () => {
    getUsersProfile()
      .then((res) => {
        setUserProfile(res);
        Storage.setItem(USERPROFILE, res);
        console.log(profile);
      })
      .catch((err) => console.log("ERROR ", err));
  };
  
  if (!profile) {
    return <Loader />;
  } else {
    return (
      <div className={styles.root}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Text variant="xl" tag="h1" style={{ fontWeight: "700" }}>
              My Account
            </Text>
            <Text variant="sm" color="secondary">
              All your account setting
            </Text>
          </div>
          <Header hidden />
        </div>

        <div>
          <div style={{ margin: "3rem 0" }}>
            <div
              style={{
                display: "flex",
                // alignItems: "center",
                gap: "1rem",
                cursor: "pointer",
              }}
            >
              <img
                src={profile.pic}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "20px",
                }}
              />
              <div>
                <Text variant="lg" style={{ fontWeight: "600" }}>
                  {profile.firtsName} {profile.lastName}
                </Text>
                <Status variant="completed" text="KYC Completed" />
              </div>
            </div>
          </div>
          <div className={styles.Menu}>
            <SettingsCard
              icon={<img src={icons.acc1} alt="account icon" />}
              innerText="Edit yout basic data"
              text="Profile setting"
              action={() => startTransition(() => navigate("profile-setting"))}
            />
            <SettingsCard
              icon={<img src={icons.acc2} alt="account icon" />}
              innerText="Add your Bnak verification number"
              text="BVN settings"
              action={() => startTransition(() => navigate("bvn-setting"))}
            />
            <SettingsCard
              icon={<img src={icons.acc3} alt="account icon" />}
              innerText="Update your account KYC"
              text="Update KYC"
              action={() => startTransition(() => navigate("update-kyc"))}
            />
            {/* <SettingsCard
              icon={<img src={icons.acc4} alt="account icon" />}
              innerText="Enter your next of kin details"
              text="Next of Kin settings"
              action={() => startTransition(() => navigate("next-of-kin"))}
            /> */}
            <SettingsCard
              icon={<img src={icons.acc5} alt="account icon" />}
              innerText="Change you account password"
              text="Password settings"
              action={() => startTransition(() => navigate("password-setting"))}
            />
            <SettingsCard
              icon={<img src={icons.acc6} alt="account icon" />}
              innerText="Change your trandation pin"
              text="Transaction Pin Settings"
              action={() => startTransition(() => navigate("transaction-pin"))}
            />
            <SettingsCard
              icon={<img src={icons.acc7} alt="account icon" />}
              innerText="Add your bank details"
              text="Bank settings"
              action={() =>
                startTransition(() =>
                  navigate("bank-setting")
                )
              }
            />
            <SettingsCard
              icon={<img src={icons.acc8} alt="account icon" />}
              innerText="Logout of your account"
              text="Logout"
              action={() => navigate("/logout")}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default Account;
